// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__1ETgT","actionsCol":"EnrolledClinics_actionsCol__2uwLR"};